/* eslint-disable no-param-reassign */
import {
  insertNodes, isElement, mergeDeepToNodes, TNode, TNodeEntry,
} from '@udecode/plate-core';
import { v4 as uuidv4 } from 'uuid';
import { DreamElementOrText, DreamWithOverride } from '../../plate';
import { ELEMENT_IMAGE } from '../../pluginKeys';

export const withCopyPaste: DreamWithOverride = (editor) => {
  const { insertData } = editor;

  const insertPastedNodes = (nodes: DreamElementOrText | DreamElementOrText[]) => {
    nodes = Array.isArray(nodes) ? nodes : [nodes];
    nodes.forEach(
      (node) => {
        mergeDeepToNodes({
          node,
          source: () => ({ id: uuidv4() }),
          query: {
            filter: (entry: TNodeEntry<TNode>) => {
              const [entryNode] = entry;
              return isElement(entryNode);
            },
          },
        });
      },
    );

    insertNodes(editor, nodes);
  };

  editor.insertData = (data: DataTransfer) => {
    if (data.types.includes('text/plain')) {
      const text = data.getData('text/plain');

      try {
        const textJSONRaw = JSON.parse(text);

        if (textJSONRaw?.copyingElement) {
          const textJSON = textJSONRaw.element;
          insertPastedNodes(textJSON);
        } else {
          insertData(data);
        }
      } catch (e) {
        insertData(data);
        /*  */
      }
    } else if (data.types.includes('Files')) {
      // for now only handle image files,
      // TODO: later it should also handle audio file for media embed
      // REVIEW: How the loading state should be handled and displayed to user?
      Promise.all(
        Array.from(data.files)
          .filter((file) => file.type.startsWith('image/'))
          .map((file) => editor?.fileManager?.upload(file)
            .then((url) => ({
              type: ELEMENT_IMAGE,
              url,
              children: [{ text: '' }],
            }))
            .catch(() => ({
              type: ELEMENT_IMAGE,
              children: [{ text: '' }],
            }))),
      )
        .then((n) => insertPastedNodes(n as DreamElementOrText | DreamElementOrText[]))
        .catch(() => { /* nothing */ });
    } else {
      insertData(data);
    }
  };
  return editor;
};
